import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { PageTitle } from 'fn-common-ui';

import SelectInput from '../forms/select-input';

@inject('store')
@observer
export default class AdminSubHeader extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.store = this.props.store;
    this.newMasterStore = this.store.newMasterStore;
    this.roles = this.newMasterStore.Roles;
    this.users = this.store.userStore;

    this.roles.fetchRoles();
  }

  handleModeSwitch = (newStatus) => {
    this.newMasterStore.changeMode(newStatus);
  }

  changeToEditMode = () => {
    this.handleModeSwitch('EDIT');
  }

  changeToViewMode = () => {
    this.handleModeSwitch('VIEW');
    this.roles.resetContent();
  }

  changeToViewAsMode = () => {
    this.handleModeSwitch('VIEW-AS');
  }

  changeContentToRole = (roleIdentifier) => {
    this.roles.changeContentToRole(roleIdentifier);
  }

  renderViewAsModeActions = () => {
    const selectedRole = this.roles.selectedRole || '';
    return (
      <div className="subheader__title">
        <PageTitle>
          View mode enabled. Viewing as
          <span className="sr-only">{selectedRole.description}</span>
        </PageTitle>
        <SelectInput
          id="view-as-dropdown"
          value={selectedRole.description}
          placeholder="Select a role..."
          labelText="Select a role"
          labelIsSrOnly={true}
          optionsList={this.roles.allRoleSelectionOptions}
          onChange={(id, value) => {this.changeContentToRole(value)}} />
        <button className="as-link" onClick={this.changeToViewMode}>
          <i className="icon-arrow-circle-left" aria-hidden={true} />
          Exit and return home
        </button>
      </div>
    );
  }

  renderEditModeActions = () => {
    return (
      <div className="subheader__title">
        <PageTitle>Edit mode enabled</PageTitle>
        <button onClick={this.changeToViewMode}>
          <i className="icon-arrow-circle-left" aria-hidden={true} />
          Exit and return home
        </button>
      </div>
    );
  }

  renderViewModeActions = () => {
    return (
      <div className="subheader__actions">
        <button onClick={this.changeToEditMode}>
          <i className="icon-pencil-alt" aria-hidden={true} />
          Edit content
        </button>
        <button onClick={this.changeToViewAsMode}>
          <i className="icon-user" aria-hidden={true} />
          View as
        </button>
      </div>
    );
  }

  renderToolbarContents = () => {
    switch (this.newMasterStore.mode) {
      case 'VIEW-AS':
        return this.renderViewAsModeActions();
      case 'EDIT':
        return this.renderEditModeActions();
      default:
        return this.renderViewModeActions();
    }
  }

  render() {
    return (
      <div className="subheader">
        <div className="container">
          <div className="row subheader__toolbar">
            {this.renderToolbarContents()}
          </div>
        </div>
      </div>
    );
  }
}
